const WHITESPACE_REGEX = /\s/g

export const InternalOrderFromJson = (json: IInternalOrderResponse): IInternalOrderModel => {
	const {
		cost_direction,
		production_date,
		delivery_date,
		employee_first_name,
		employee_last_name,
		created_by_employee_id,
		created_by_employee,
		delivery_address,
		created_at,
		updated_at,
		...rest
	} = json
	return {
		...rest,
		costDirection: cost_direction,
		productionDate: production_date,
		deliveryDate: delivery_date,
		employeeFirstName: employee_first_name ?? null,
		employeeLastName: employee_last_name ?? null,
		createdByEmployeeId: created_by_employee_id,
		createdByEmployee: created_by_employee
			? { firstName: created_by_employee.first_name, lastName: created_by_employee.last_name }
			: null,
		deliveryAddress: delivery_address,
		items: json.items.map(item => ({
			variantId: item.variant_id,
			mealId: item.meal_id,
			quantity: item.quantity,
		})),
		createdAt: created_at,
		updatedAt: updated_at,
	}
}

const buildDeliveryAddressPayload = (form: IInternalOrderForm): IInternalOrderAddressPayload => ({
	building_type: form.buildingType,
	city: form.city,
	district: form.district || null,
	postcode: form.postcode,
	street: form.street,
	building_number: form.buildingNumber,
	apartment_number: form.apartmentNumber || null,
	staircase: form.staircase || null,
	floor: form.floor || null,
	entry_code: form.entryCode || null,
	delivery_from: form.deliveryFrom || null,
	delivery_until: form.deliveryUntil,
	delivery_place: form.deliveryPlace,
	delivery_phone_number: form.deliveryPhoneNumber
		? `${form.deliveryPhoneNumberCode?.dialCode ?? ''}${form.deliveryPhoneNumber.replace(WHITESPACE_REGEX, '')}`
		: null,
	is_alternative_delivery_phone_number: form.isAlternativeDeliveryPhoneNumber,
	courier_instructions: form.courierInstructions || null,
	custom_name: form.customName || null,
})

export const InternalOrderToCreatePayload = (
	form: IInternalOrderForm,
	items: IInternalOrderFormItem[],
): IInternalOrderPayload => ({
	purpose: form.purpose,
	cost_direction: form.costDirection,
	production_date: form.productionDate ? dateToFilterFormat(form.productionDate) : '',
	delivery_date: form.deliveryDate ? dateToFilterFormat(form.deliveryDate) : '',
	employee_first_name: form.employeeFirstName || null,
	employee_last_name: form.employeeLastName || null,
	delivery_address: buildDeliveryAddressPayload(form),
	items: items.map(item => ({
		variant_id: item.variantId,
		quantity: item.quantity,
	})),
})
